import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/card";
import { ChartContainer, ChartLegend, ChartLegendContent, ChartTooltip, ChartTooltipContent } from "@/components/chart";
import type { JiraMetricsCFDPoint } from "@/http/api-types";
import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from "recharts";

export function CfdChart({ data }: { data: JiraMetricsCFDPoint[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Cumulative Flow Diagram</CardTitle>
        <CardDescription>Status snapshots at the end of the weeks</CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer
          className="h-72 w-full"
          config={{
            in_progress_count: { label: "In Progress", color: "#0ea5e9" },
            review_requested_count: { label: "Review Requested", color: "#f59e0b" },
            in_review_count: { label: "In Review", color: "#8b5cf6" },
            changes_requested_count: { label: "Changes Requested", color: "#ef4444" },
            changes_approved_count: { label: "Changes Approved", color: "#14b8a6" },
          }}
        >
          <AreaChart data={data}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="period" />
            <YAxis />
            <ChartTooltip content={<ChartTooltipContent />} />
            <ChartLegend content={<ChartLegendContent />} />
            <Area
              type="monotone"
              dataKey="in_progress_count"
              stroke="var(--color-in_progress_count)"
              strokeWidth={2}
              fill="var(--color-in_progress_count)"
              fillOpacity={0.2}
              stackId="status"
            />
            <Area
              type="monotone"
              dataKey="review_requested_count"
              stroke="var(--color-review_requested_count)"
              strokeWidth={2}
              fill="var(--color-review_requested_count)"
              fillOpacity={0.2}
              stackId="status"
            />
            <Area
              type="monotone"
              dataKey="in_review_count"
              stroke="var(--color-in_review_count)"
              strokeWidth={2}
              fill="var(--color-in_review_count)"
              fillOpacity={0.2}
              stackId="status"
            />
            <Area
              type="monotone"
              dataKey="changes_requested_count"
              stroke="var(--color-changes_requested_count)"
              strokeWidth={2}
              fill="var(--color-changes_requested_count)"
              fillOpacity={0.2}
              stackId="status"
            />
            <Area
              type="monotone"
              dataKey="changes_approved_count"
              stroke="var(--color-changes_approved_count)"
              strokeWidth={2}
              fill="var(--color-changes_approved_count)"
              fillOpacity={0.2}
              stackId="status"
            />
          </AreaChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
